/**
 * Sanitize a schema string by replacing closing script tags.
 * Closing script tags appear to be the only ones that can break
 * the page layout when used on the Structured Data schemas
 * @param {String} schemaString
 */
export const sanitizeSchemaString = (schemaString) =>
  schemaString.replace(/<\/script/gi, '&lt;/script');
